// Заказан
export const ORDERED_BY_CUSTOMER = 1;

// Отправлен поставщику active at sup
export const REQUESTED_FROM_SUPPLIER = 2;

// Подтвержден поставщиком active at sup
export const APPROVED_BY_SUPPLIER = 4;

// Ожидается на складе  archive at sup
export const EXPECTED_IN_STOCK = 6;

// На складе 
export const IN_STOCK = 8;

// Отправлен заказчику
export const SENDED_TO_CUSTOMER = 9;

// Получен
export const RECEIVED_BY_CUSTOMER = 7;

// Отменен поставщиком
export const CANCELED_BY_SUPPLIER = 5;

// Отменет администратором
export const CANCELED_BY_ADMIN = 12;



/** WEBPACK FOOTER **
 ** ./src/constants/orderStateConstatns.js
 **/